import React from 'react'
import { Skeleton } from 'antd'
import { useTranslation } from 'react-i18next'

import LeadCard from '../../components/LeadCard/LeadCard.component'
import EmptyState from '../../components/EmptyState/EmptyState.component'
import { useLeads } from '../../hooks'

import './LeadsPage.styles.css'

const LeadsPage: React.FC = () => {
  const { t } = useTranslation()
  const { leads, loading, markProcessed, isEmpty } = useLeads()
  const currentLead = leads[0]

  return (
    <div className="leads-page">
      <div className="leads-page-header">
        <h1 className="leads-page-title">{t('leads', { ns: 'standard' })}</h1>
        <p className="leads-page-subtitle">{t('leads-management', { ns: 'standard' })}</p>
      </div>

      <div className="leads-page-content">
        {loading && !currentLead && <Skeleton active />}
        {!loading && isEmpty && (
          <EmptyState
            icon="🎯"
            title={t('no-unprocessed-leads', { ns: 'standard' })}
            description={t('no-unprocessed-leads-description', { ns: 'standard' })}
          />
        )}
        {currentLead && (
          <LeadCard
            lead={currentLead}
            loading={loading}
            onProcess={(isTarget) => markProcessed(currentLead.id, isTarget)}
          />
        )}
      </div>
    </div>
  )
}

export default LeadsPage